import { render, staticRenderFns } from "./FilterOptionComponent.vue?vue&type=template&id=28b0725f&scoped=true&"
import script from "./FilterOptionComponent.vue?vue&type=script&lang=ts&"
export * from "./FilterOptionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0725f",
  null
  
)

export default component.exports